const cardTokens = ({ radii }) => ({
  radii: radii.small,
  sizesRadii: {
    small: radii.small,
    full: radii.small,
  },
});

export default cardTokens;
